import { useContext } from 'react';

import { useMutation } from '@tanstack/react-query';
import type { CacheRequestConfig } from 'axios-cache-interceptor';

import { ConfigContext } from '../../../../aurr/contexts/ConfigContext';
import LoginContext from '../../../../aurr/contexts/LoginContext';
import { getAxiosInstance } from '../../../axiosCache';
import { REPLIES_FLAG_KEY } from '../../constants';

export interface FlagReplyParams {
  baseURL?: string;
  commentId: string;
  body: string;
}

export const useKhorosFlagReply = ({
  commentId,
  body,
  baseURL,
}: FlagReplyParams) => {
  const { KHOROS_API } = useContext(ConfigContext);
  const { access_token, userProfile } = useContext(LoginContext);
  const sub = userProfile?.sub || '';

  const axiosConfig: CacheRequestConfig = {
    baseURL: baseURL || KHOROS_API,
    headers: {
      ...(access_token && { authorization: `Bearer ${access_token}` }),
    },
  };

  const api = getAxiosInstance();

  return useMutation({
    mutationKey: [REPLIES_FLAG_KEY, { commentId, sub }],
    mutationFn: async () => {
      const response = await api.post(
        `/services/v2/community/khoros/flag-comment`,
        {
          commentId,
          body,
        },
        axiosConfig
      );
      return response?.data || undefined;
    },
  });
};
